import React from 'react';
import { RefreshCw, Flame, ExternalLink } from 'lucide-react';
import { OpportunitiesData } from '../data/mockData';
interface OpportunitiesTilesProps {
  opportunities: OpportunitiesData;
}
const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
  notation: val >= 1000000 ? 'compact' : 'standard'
}).format(val);
export function OpportunitiesTiles({
  opportunities
}: OpportunitiesTilesProps) {
  const tiles = [{
    label: 'Retention & Recapture',
    count: opportunities.retentionRecapture.count,
    volume: opportunities.retentionRecapture.volume,
    subtitle: 'Past borrowers with rate improvement opportunities',
    icon: RefreshCw,
    accent: 'amber'
  }, {
    label: 'Hot Leads',
    count: opportunities.hotLeads.count,
    volume: opportunities.hotLeads.volume,
    subtitle: 'High-priority leads ready for outreach',
    icon: Flame,
    accent: 'orange'
  }];
  const accentStyles: Record<string, {
    icon: string;
    glow: string;
    border: string;
  }> = {
    amber: {
      icon: 'text-amber-400 bg-amber-500/15',
      glow: 'bg-amber-500',
      border: 'hover:border-amber-500/30'
    },
    orange: {
      icon: 'text-orange-400 bg-orange-500/15',
      glow: 'bg-orange-500',
      border: 'hover:border-orange-500/30'
    }
  };
  return <section data-id="element-245">
      <h2 className="text-lg font-semibold text-white mb-4 flex items-center gap-2" data-id="element-246">
        <span className="w-1.5 h-5 bg-amber-500 rounded-full" data-id="element-247"></span>
        Opportunities
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-248">
        {tiles.map(tile => {
        const styles = accentStyles[tile.accent];
        const Icon = tile.icon;
        return <div key={tile.label} className={`bg-slate-800/80 border border-slate-700/50 rounded-xl p-5 ${styles.border} transition-all duration-200 shadow-lg group relative`} data-id="element-249">
              {/* Top glow */}
              <div className="absolute top-0 left-0 w-full overflow-hidden rounded-t-xl" data-id="element-250">
                <div className={`w-full h-0.5 opacity-50 group-hover:opacity-100 transition-opacity ${styles.glow}`} data-id="element-251" />
              </div>

              <div className="flex items-start justify-between mb-3" data-id="element-252">
                <div className={`p-2 rounded-lg ${styles.icon}`} data-id="element-253">
                  <Icon className="w-5 h-5" data-id="element-254" />
                </div>
                <div className="text-right" data-id="element-255">
                  <span className="text-xs text-slate-400 font-medium" data-id="element-256">
                    Potential Volume
                  </span>
                  <div className="text-sm font-semibold text-slate-200" data-id="element-257">
                    {formatCurrency(tile.volume)}
                  </div>
                </div>
              </div>

              <div className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-1" data-id="element-258">
                {tile.count}
              </div>

              <div className="text-sm font-medium text-slate-300" data-id="element-259">
                {tile.label}
              </div>
              <div className="text-sm text-slate-400 mt-0.5" data-id="element-260">
                {tile.subtitle}
              </div>

              {/* Redirect icon */}
              <button className="absolute bottom-4 right-4 p-2 rounded-lg text-slate-500 hover:text-white hover:bg-slate-700/60 transition-all opacity-0 group-hover:opacity-100 cursor-pointer" data-id="element-261">
                <ExternalLink className="w-4 h-4" data-id="element-262" />
              </button>
            </div>;
      })}
      </div>
    </section>;
}